import React from "react";
import DashboardLayout from "./DashboardLayout";

/** The customer panel. The frame itself lives in DashboardLayout. */
const UserDashboardLayout = (props) => <DashboardLayout {...props} />;

export default UserDashboardLayout;
